import React from 'react';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const BulkActionsBar = ({ 
  selectedCount = 0, 
  totalCount = 0, 
  onSelectAll, 
  onClearSelection, 
  onBulkApprove, 
  onBulkFlag, 
  onBulkDelete,
  isAllSelected = false 
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <Checkbox
            checked={isAllSelected}
            onChange={onSelectAll}
            indeterminate={selectedCount > 0 && !isAllSelected}
          />
          
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={16} className="text-primary" />
            <span className="text-sm font-medium text-foreground">
              {selectedCount} of {totalCount} items selected
            </span>
          </div>
        </div>

        <div className="flex items-center space-x-2">
          <Button
            variant="success"
            size="sm"
            iconName="Check"
            iconSize={14}
            onClick={onBulkApprove}
          >
            Approve Selected
          </Button>
          
          <Button
            variant="warning"
            size="sm"
            iconName="Flag"
            iconSize={14}
            onClick={onBulkFlag}
          >
            Flag Selected
          </Button>
          
          <Button
            variant="destructive"
            size="sm"
            iconName="Trash2"
            iconSize={14}
            onClick={onBulkDelete}
          >
            Delete Selected
          </Button>
          
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            iconSize={14}
            onClick={onClearSelection}
          >
            Clear Selection
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;